import axios from 'axios';
import { BnplTerms, OptionStatus } from '../functions/paymentOptionLabel';

export type BnplIntentResponse = {
    intent_uuid: string;
    status?: OptionStatus;
};

export async function createBnplIntent(
    invoiceUuid: string,
    terms: BnplTerms
): Promise<BnplIntentResponse> {
    const { data } = await axios.post<BnplIntentResponse>(
        import.meta.env.VITE_API_BASE_URL + 'web/invoice/' + invoiceUuid + '/bnpl-intent/',
        { terms }
    );
    return data;
}

const WAITING = new Set(['pending', 'created']);

/** Same terms, same intent — keep calling until Two answers. */
export async function waitForBnplIntent(
    invoiceUuid: string,
    terms: BnplTerms,
    attempts = 8,
    delayMs = 1000
): Promise<BnplIntentResponse> {
    let last: BnplIntentResponse = { intent_uuid: '' };
    for (let i = 0; i < attempts; i++) {
        last = await createBnplIntent(invoiceUuid, terms);
        const status = (last.status ?? 'approved').toLowerCase();
        if (!WAITING.has(status)) {
            return last;
        }
        if (delayMs > 0) {
            await new Promise((resolve) => setTimeout(resolve, delayMs));
        }
    }
    return last;
}
